var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F89521"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4C17.433 4 19 5.567 19 7.5S17.433 11 15.5 11 12 9.433 12 7.5 13.567 4 15.5 4zm0 1.5c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2zM6.243 7.897l.088.073L10 11.5l-3.67 3.53c-.304.293-.797.293-1.102 0-.276-.266-.302-.683-.075-.976l.075-.084 1.746-1.68H1.803c-.414 0-.75-.336-.75-.75 0-.376.277-.688.64-.742l.11-.008h5.256l-1.83-1.76c-.277-.266-.303-.683-.076-.976l.075-.084c.277-.267.71-.29 1.015-.073zM17.5 12c2.485 0 4.5 2.015 4.5 4.5V19c0 1.105-.895 2-2 2h-9c-1.105 0-2-.895-2-2v-2.5c0-2.485 2.015-4.5 4.5-4.5h4zm0 1.5h-4c-1.598 0-2.904 1.249-2.995 2.824l-.005.176V19c0 .245.177.45.41.492l.09.008h9c.245 0 .45-.177.492-.41L20.5 19v-2.5c0-1.598-1.249-2.904-2.824-2.995L17.5 13.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.be83b2e5a7db3faa7941084684d0cf08.svg";
export { ForwardRef as ReactComponent };